import DeauvilleFebruary2026 from "../../components/before-after/DeauvilleFebruary2026";

const DeauvilleFebruary2026View = () => {

    return (
        <div className="before-after-deauville-february-2026">
            <DeauvilleFebruary2026/>
        </div>
    );
};

export default DeauvilleFebruary2026View;